import { useEffect } from 'react';
import { z } from 'zod';
import { createZodFormResolver, SubmitHandler, useFormControls } from '@mews/framework';

const schema = z.object({
    exemptedEnterpriseProfileIds: z.array(z.string()),
    enforceAuthenticatorSetup: z.boolean().optional(),
});

export type formValues = z.infer<typeof schema>;

const resolver = createZodFormResolver<formValues>(schema);

export const useMfaSetupForm = ({
    exemptedEnterpriseProfileIds,
    enforceAuthenticatorSetup,
    onSubmit,
}: {
    exemptedEnterpriseProfileIds: string[];
    onSubmit: SubmitHandler<formValues>;
    enforceAuthenticatorSetup: boolean;
}) => {
    const {
        renderFormContent,
        submit,
        watch,
        hasDirtyFields,
        reset: internalReset,
    } = useFormControls<formValues>({
        defaultValues: {
            exemptedEnterpriseProfileIds,
            enforceAuthenticatorSetup,
        },
        mode: 'onBlur',
        resolver,
        onSubmit,
        shouldFocusError: true,
    });

    // Since the form is not being mounted/unmounted, we need to reset the form when the default values change
    useEffect(() => {
        internalReset({ exemptedEnterpriseProfileIds, enforceAuthenticatorSetup });
    }, [internalReset, exemptedEnterpriseProfileIds, enforceAuthenticatorSetup]);

    return {
        renderFormContent,
        submit,
        watch,
        hasDirtyFields,
        reset: () => internalReset({ exemptedEnterpriseProfileIds, enforceAuthenticatorSetup }),
    };
};
